export const MOBILE_PAGINATION_NAV_SX = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  px: 0,
  py: 1.25
}

export const getMobilePaginationPaperSx = (theme) => ({
  width: '100%',
  py: 1.25,
  px: 1.5,
  borderRadius: 3,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[2],
  bgcolor: 'background.paper'
})

export const MOBILE_PAGINATION_CAPTION_SX = {
  mb: 0.9,
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.2
}

export const mergeMobilePaginationNavSx = (navSx) => (theme) => ({
  ...MOBILE_PAGINATION_NAV_SX,
  ...(typeof navSx === 'function' ? navSx(theme) : navSx || {})
})

export const mergeMobilePaginationPaperSx = (paperSx) => (theme) => ({
  ...getMobilePaginationPaperSx(theme),
  ...(typeof paperSx === 'function' ? paperSx(theme) : paperSx || {})
})
